<template>
  <div class="order-goods">
    <div class="header">
      <img src="../../static/logo.png" />
      <h2>锐道咨询</h2>
    </div>
    <div>
      <van-cell-group>
        <div style="display:flex;align-items:center;margin-left:14px">
          <div style="font-size:14px;margin-right:10px">项目</div>
          <h4>{{title}}</h4>
        </div>
        <van-cell title="单价" :value="'¥'+unit_price"></van-cell>
        <van-cell title="数量">
          <van-stepper v-model="num" />
        </van-cell>
      </van-cell-group>
    </div>
    <div style="marign-top:20px;">
      <van-field v-model="name" label="姓名" placeholder="请输入姓名" />
      <van-field v-model="mobile" label="手机" placeholder="请输入手机号" />
      <van-field
        v-model="remark"
        rows="2"
        autosize
        label="留言"
        type="textarea"
        placeholder="如有销售. 建议写上销售姓名"
      />
    </div>
    <div style="text-align:center;color:gray;font-size:14px">建议填写姓名和手机方便财务确认打款人</div>
    <van-submit-bar :price="price" button-text="提交订单" @submit="onSubmit" />
  </div>
</template>
<script>
// import ;
export default {
  data() {
    return {
      remark: "",
      name: "",
      mobile: "",
      title: "",
      src: "",
      num: 1,
      unit_price: null,
      id: "",
      weixin_pay: {
        appId: "", //公众号名称，由商户传入
        timeStamp: "", //时间戳，自1970年以来的秒数
        nonceStr: "", //随机串
        package: "",
        signType: "", //微信签名方式：
        paySign: "" //微信签名
      }
    };
  },
  computed: {
    price() {
      return this.num * this.unit_price * 100;
    }
  },
  methods: {
    onSubmit() {
      this.$router.push({
        path: "./ttt",
        query: {
          num: this.num,
          title: this.title,
          price: this.price / 100
        }
      });
      this.$http.post("/oa/wxgoods/goodPay?id=" + 4).then(res => {
        const sign_prepay = { prepay_id: res.data.data.prepay_id };
        this.$http
          .post("/oa/weixinpay/getpayjsticket", sign_prepay)
          .then(res => {
            this.weixin_pay = res.data;
            WeixinJSBridge.invoke(
              "getBrandWCPayRequest",
              this.weixin_pay,
              function(res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                  window.location.reload();
                }
              }
            );
          });
      });
    }
  },
  created() {
    this.$http
      .get("/oa/wxgoods/goodsInfo?id=" + this.$route.query.id)
      .then(res => {
        const info = res.data.data.info;
        this.unit_price = info.unit_price;
        console.log(this.unit_price);

        this.title = info.title;
      });
  }
};
</script>
<style >
.van-field__label {
  width: 48px;
}
</style>
<style scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: center;
}
.header img {
  width: 70px;
  height: 70px;
}
.header .font {
  font-size: 20px;
  color: red;
}
.content {
  display: flex;
  justify-content: space-between;
  margin: 0 20px;
}
.order-goods {
  margin: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/paymoney.vue